/**
 * Naming conventions:
 *  WATERING: the name of the mode and the message when toggling modes.
 *  WATERED: Successfully preformed the action.
 *  NO_WATER: Error message when out of given resource.
 */
export const getMessages = {
    "welcome": "Click the green grass below to plant a tree.",
    "PLANTING": "Plant some trees!",
    "WATERING":"Click a tree to watch it grow!",
    "WATERED": "Look at that tree grow!",
    "NO_WATER": "Out of water? Oh well.",
    "HARVEST": "Click a tree to chop it down.",
    "HARVESTING": "Chop chop.",
    "NO_TREES": "Oops! No trees to harvest.",
    "GNOME": "Bop those darn gnomes.",
};